export var StringsES = {
    // Buttons
    buttons: {
        button_logout: 'Salir',
        button_accept: 'Aceptar',
        button_cancel: 'Cancelar',
        button_individualUsers_title: 'Usuarios individuales',
        button_individualUsers_text: 'Licencias de prueba, test de usabilidad, etc.',
        button_corporateUsers_title: 'Licencias corporativas',
        button_corporateUsers_text: 'Licencias reales para hospitales',
        button_analysisCount_title: 'Análisis de uso',
        button_analysisCount_text: 'Contabilizar el número de análisis',
        button_targetRegion: 'Región objetivo',
        button_targetLanguage: 'Idioma objetivo',
        button_createLicense: 'Crear licensia',
        button_dbCollaborator: 'Colaborates for body composition poblational model',
        button_emailAndPasswordAuth: 'Login con usuario y contraseña',
        button_passwordRotation: 'Política de rotación de contraseñas (días)',
        button_dateRange: 'Rango de fechas',
        button_download: 'Descargar',
    },
    // Messages
    messages: {
        // Individual users
        section_newUser: 'Nuevo usuario',
        input_box_email: 'Usuario',
        output_password: 'Contraseña',
        section_existingUsers: 'Usuarios existentes',
        info_copiedToClipboard: 'Valor copiado al portapapeles',
        popupTitle_genericSuccess: 'Éxito',
        popupTitle_genericDangerous: 'Se necesita confirmación',
        // Corporate users
        tab_generalSettings: 'Configuración general',
        tab_userSettings: 'Configuración de usuarios',
        section_newDomain: 'Nuevo Dominio',
        section_existingDomains: 'Dominio existente',
        input_box_adminEmail: 'Correo del administrador',
        input_box_notificationEmail: 'Correo para notificaciones',
        input_box_nDays: 'Duration de la licencia (días)',
        boolean_yes: 'Sí',
        boolean_no: 'No',
        input_box_startingTimestamp: 'Fecha de creación',
        input_box_endingTimestamp: 'Fecha de finalización',
        // Licenses
        info_updatingLicense: 'Actualizando license...',
        info_creatingLicense: 'Creando licencia...',
        info_licenseCreated: 'Licencia creada correctamente',
        info_gettingLicenses: 'Obteniendo la lista de licencias...',
        info_deletingLicense: 'Eliminando licencia de usuario...',
        info_licenseDeleted: 'Licencia eliminada correctamente',
        confirmation_deleteLicense: '¿Está seguro de que desea eliminar esta licencia?',
        confirmation_userAdded: 'Usuario añadido correctamente',
        confirmation_domainRemoved: 'Dominio eliminado correctamente',
        // Changes
        pupupTitle_unsavedChanges: 'Hay cambios sin guardar',
        pupupText_unsavedChanges: '¿Quiere guardarlos antes de continuar?',
        // Dangerous actions
        pupupTitle_dangerousAction: 'Acción peligrosa',
        pupupText_dangerousAction_deleteDomain: '¿Quiere eliminar de forma irreversible este dominio?',
        // Analysis count
        cardTitle_userAnalysisCount: 'Número de análisis por usuario',
        cardTitle_domainAnalysisCount: 'Número de análisis por dominio',
        cardTitle_globalAnalysisCount: 'Número de análisis global',
        cardTitle_domainActivity: 'Actividad del dominio',
        input_box_domain: 'Dominio',
        cartText_analysisCount: 'Total de análisis ejecutados en todos los dominios durante el periodo seleccionado.',
        info_gettingInformation: 'Obteniendo información...'
    },
    // Erros
    errors: {
        // Format (according to validators for one specific field)
        format_error_email: 'Formato del correo erroneo',
        format_error_nDays: 'La duración especificada no es válida',
        // Standard errors      
        popupTitle_generic: 'Error',
        // License actions
        action_unableToCreateLicense: 'No ha sido posible crear la licencia',
        action_unableToGetLicenses: 'No ha sido posible obtener la lista de licencias',
        action_unableToGetLicenseInformation: 'No ha sido posible obtener la información de la licencia',
        action_userAlreadyExists: 'El usuario ya existe',
        action_unableToUpdateLicense: 'No ha sido posible actualizar la licencia',
        action_unableToDeleteDomain: 'No ha sido posible eliminar el dominio',
    },
    // Regions
    regions: {
        eu: 'Europa (EU)',
        uk: 'Reino Unido (UK)',
        us: 'Estados Unidos (US)'
    }
}